export default {
  login: {
    welcomeMsg: "Benvenuto! Accedi",
    info: "Inserisci le tue credenziali.",
    forgot: "Password dimenticata?",
    btn: "Accedi",
    unableToLogin: "Non è possibile accedere",
  },
  forgot: {
    info_l1:
      "Inserisci l'indirizzo email associato al tuo account. I dettagli della password saranno inviati al tuo indirizzo email/mobile.",
    info_l2:
      "Inserisci il tuo numero di cellulare associato al tuo account. I dettagli della password saranno inviati al numero di telefono.",
    info_l3:
      "Si prega di scegliere una delle seguenti opzioni per ricevere istruzioni su come ripristinare la password",
    forgotQ: "Hai dimenticato la password?",
    loginNow: "Accedi ora",
    resetSucc: "La password viene ripristinata con successo",
    resetSucc_l2:
      "È ora possibile utilizzare la nuova password per accedere al tuo account.",
    entPsw: "Inserisci la nuova password.",
    resetPsw: "Reimposta la password",
    resendOTP: "Invia OTP",
    enterCorrectOTP: "Si prega di inserire OTP corretto.",
    enterOTP: "Si prega di inserire OTP ricevuti via e-mail/mobile.",
    backToLoginPage: "Torna alla pagina di Login",
    recieveCodeFalse: "Non ho ricevuto il codice",

    "changePassword": "Cambia password",
    "changePasswordSubtitle": "Inserisci la tua nuova password qui sotto",
    "oldPassword": "Vecchia password",
    "newPassword": "Nuova password",
    "confirmPassword": "Conferma password",
    "resetPassword": "Reimposta password",
    "resetPasswordSubtitle": "Inserisci la tua nuova password qui sotto",
    "resetPasswordBtn": "Reimposta password",
    "backToLogin": "Torna al login",
    "oldPasswordRequired": "La vecchia password è obbligatoria",
    "passwordResetSuccess": "Password reimpostata con successo",
    "passwordResetFailed": "Impossibile reimpostare la password",
    "errorOccurred": "Si è verificato un errore"
  },
  permissions: {
    savePermissions: "SAVE PERMISSIONI",
    moduleName: "Nome del modulo",
    view: "Vista",
    create: "Creare",
    update: "Aggiornamento",
    delete: "Cancella",
    permissionsUpdated: "Permissioni aggiornate",
    permissionsNotUpdated: "Permissioni non aggiornate",
    selectMembership: "Seleziona l'iscrizione",
    noPermMsg:
      "Si prega di selezionare il tipo di appartenenza utilizzando il 'Tipo di Membership' discesa sopra per visualizzare le autorizzazioni",
    selectRoleMsg:
      "Si prega di selezionare il ruolo sopra per mostrare le autorizzazioni",
  },
  activationKey: {
    enterActivationKey:
      "Inserisci il tasto di attivazione per registrare un nuovo utente",
    mitigation: "Mitigazione del rischio manuale",
    countryRequired: "Paese è richiesto",
    activationKeyRequired: "La chiave di attivazione è richiesta",
    activationKey: "Chiave di attivazione",
    activationKeyLimit: "Chiave di attivazione troppo breve",
    membershipRoleFilterDesc: "Filtra Membership Piano di Role",
    email: "Email",
    filterBy: "Filtra per",
    membershipRoleFilter: "Filtro di ruolo",
    appointSalesManager: "Nomina Sales Manager",
    appointManager: "MANAGER",
    salesManAppSuccess: "SALES MANAGER APPOINTED SUCCESSFULLE",
    uploadData: "DATI ISCRITTI CSV",
    uploadUserData: "Si prega di caricare il file dei dati dell'utente",
    downloadCsv: "Scarica il file .csv campione per seguire la struttura",
    downloadSample: "Scarica il file campione",
    dragDrop: "Drag e drop o",
    browse: "sfoglia",
    yourFile: "il tuo file",
    pdfSupport: "Sono supportati solo file PDF.",
    pleaseWait: "Per favore aspetta",
    note: "Notitie",
    incorectFileType: "Tipo di file non corretto",
    somethingWentWrong: "Qualcosa non va",
    fileUploadedSuccess: "File Caricato con successo",
    countRecords: "Count Records",
    sendNow: "FINE ORA",
    fileName: "file-name",
    assignActKey: "Assegnare chiavi di attivazione",
    actKeyAssSucc: "Tasti di attivazione assegnati con successo",
    viewActKey: "VISTA ATTIVITÀ",
    actKeyQuota: "Chiavi di attivazione Quota",
    genActKey: "Chiave di attivazione generata",
    remActKey: "Tasti di attivazione rimanenti",
    penUsed: "In attesa e chiavi usate",
    activationKeyAss: "Tasti di attivazione Assegnati",
    activationKeyUnass: "Chiavi di attivazione non firmate",
    keysAct: "Chiavi attivate",
    uploadedFiles: "File caricati",
    generateActKey: "ATTIVITÀ",
    showData: "Mostra i dati",
    noDataFound: "Nessun appuntamento trovato",
    pleaseGenKey:
      'Si prega di generare le chiavi di attivazione utilizzando il "Generate Activation Keyss"',
    noActKey: "Nessuna chiave di attivazione generata ancora",
    buttonAbv: "pulsante sopra",
    numberOfActKey: "Numero di chiavi di attivazione",
    membershipRole: "Composizione Role",
    membershipPlan: "Piano di adesione",
    comments: "Osservazioni",
    genKeys: "GIUDICI GENERATI",
    keysNum: "Numero di chiavi",
    phoneNumber: "Numero di telefono",
    keysStatus: "Stato delle chiavi",
    ActivationKeysList: "Elenco delle chiavi di attivazione",
    back: "INDIETRO",
    usingActKeys: 'utilizzando il "Generate Activation Keysss"',
    pleaseGenActKeyss: "Si prega di generare le chiavi di attivazione",
    clearAllFilters: "CLEAR ALL FILTRI",
    salesManager: "Responsabile vendite",
    clearAll: "CLEARE",
    generatedBy: "Generato da",
    numberOfKeys: "Numero di chiavi",
    action: "Azione",
    viewAllUplFiles: "VISTA TUTTI I FILI SUPPLEMENTARI",
    bulkUploadUsers: "BULK UPLOAD USS",
    noActivationKeyFound: "Nessuna chiave di attivazione trovata",
    pleaseCreateAdminRole:
      "Si prega di creare ruolo amministratore utilizzando",
    btnCreateAdmin: "pulsante 'Creare Admin Role' sopra",
    donwloadAsCsv: "Scarica come CSV",
    donwloadAsPdf: "Scarica il PDF",
    assignSalesManager: "Assegnare Sales Manager",
    shareViaEmail: "Condividi via Email",
    memberRequired: "l'adesione è richiesta",
    memberRoleRequired: "Il ruolo di membro è richiesto",
    memberKeyRequired: "Valore chiave è richiesto",
    enterComment: "Inserisci il tuo commento qui",
    sendEmail: "FINE EMAIL",
    emailSend: "EMAIL SENT SUCCESSFULLE",
    donwload: "Scarica",
    deleteFile: "Elimina file",
    invalidFileData: "I dati chiave di attivazione sul file non sono validi",
  },
  profileSetting: {
    defaultOrganizationOTPForSignUp:
      "OTP dell'organizzazione di default per l'iscrizione",
    whoreceivedthealert: "Chi riceve l'Alert",
    otp: "OTP",
    passwordReuse: "Riutilizzo della password",
    organizationSplashScreen: "Schermata iniziale dell’organizzazione",
    organizationSplash1: "Organizzazione Splash",
    generateOtp: "Generare OTP",
    addAnother: "Aggiungi un altro",
    dragAndDropOr: "Drag & Drop o Sfoglia",
    browse: "Sfoglia",
    save: "Salva",
    profileAuthSettings: "Impostazioni di autenticazione del profilo",
    changeSettings: "IMPOSTAZIONI DEI CAMBI",
    loginLogoutSettings: "Impostazioni Login/Logoff",
    autoLogout: "Auto-log off",
    unsuccAtmp: "I tentativi di accesso senza successo",
    unsuccLoginLock: "Accesso senza successo Periodo di blocco",
    pswCrisetup: "Impostazione Criteri di password",
    pswLength: "Lunghezza della password",
    noOfUniquePsw: "Numero di password uniche richieste",
    maxPswAge: "Età massima della password",
    AccRangeOfchars: "Gamma accettabile di caratteri",
    upperCase: "Maiuscole",
    lowerCase: "Minuscole",
    numbers: "Numeri",
    specialChars: "Caratteri speciali",
    settingsUpdated: "Impostazioni Aggiornate",
    settingsNotUpdated: "Impostazioni Non aggiornate",
    organization: "Organizzazione",
    organizationLogo: "Logo dell'organizzazione",
    organizationSplash: "Schermata iniziale dell’organizzazione",
    cropsHarvestAlert: "Alerts del raccolto",
    alertCrop: "Coltura",
    alertCropInfo: "Crop per il quale si otterrà l'allerta",
    alertCountry: "Paese",
    alertCountryInfo: "Paese per il quale sarete avvisati",
    alertRegion: "Regione",
    alertRegionInfo:
      "Regione del paese selezionato per il quale sarete avvisati",
    alertMaximum: "Quantità massima",
    alertMaximumInfo:
      "Quantità massima consentita dopo la quale sarete avvisati",
    selectCrop: "Seleziona il raccolto",
    alertFor: "Seleziona chi riceve l'avviso",
    alertAdmin: "Avviso di amministrazione",
    alertFarmer: "Alert Farmer",
    selectCountry: "Seleziona Paese",
    selectCountryInfo:
      "Scegli la posizione geografica applicabile alla valutazione.",
    maxProduction: "Produzione massima / Ettari / Anno",
    maxAllowed: "Max consentito / Ha / Yr",
    alert: "Avviso",
    defaultOtpOrganization:
      "Organizzazione di default OTP per la registrazione",
    crop: "Coltura",
    maxProductionError: "La produzione massima deve essere inserita",
    selectCountryError: "Si prega di selezionare il paese prima",
    selectCropError: "Si prega di selezionare il raccolto prima",
    unitError: "Impostare la massima produzione e unità",
  },
  userslist: {
    existingUser: "Seleziona dall'utente app esistente",
    addRole: "Aggiungi Role",
    newUser: "Crea un nuovo utente amministratore",
    convertUser: "Convertire in utente amministratore",
    createNewUser: "Creare un nuovo utente",
    chooseCreateType: "Scegli una delle seguenti opzioni:",
    addNewUser: "Aggiungi nuovo utente",
    editUser: "Modifica utente",
    addNewAdmin: "Aggiungi utente Admin",
    userLoading: "Caricamento degli utenti... Aspetta",
    noUser: "NON DISPONIBILE",
    extendVal: "VALIDITÀ ESTERNA",
    extendReason: "Motivo di estensione",
    extendReasonMsg: "Specificare il motivo per l'estensione dei membri",
    exportAsCSV: "EXPORT AS CSV",
    membershipType: "Tipo di iscrizione",
    membershipValidity: "Validità degli iscritti",
    regionState: "Regione/Stato",
    cityTown: "Città / Town",
    clearAll: "CLEARE",
    search: "RICERCA",
    familyTribe: "Inserisci la tua tribù di famiglia",
    enterWebsite: "Inserisci il sito web",
    registrationDate: "Data di registrazione",
    single: "Singola",
    multiple: "Più",
    user: "Utente",
    users: "Utenti",
    role: "Role",
    department: "Dipartimento",
  },
  addEdituser: {
    facilityPicture: "Immagine della struttura",
    firstNameRequired: "Il primo nome è richiesto",
    roleNameOnlyAlpha: "Role Name può contenere solo alfabeti",
    roleNameLimit: "Role Il nome deve essere inferiore a 100 caratteri",
    firstNameOllyAlpha: "Il primo nome può contenere solo alfabeti",
    firstNameLimit: "Il primo nome deve essere inferiore a 50 caratteri",
    departmentRequired: "Dipartimento Campo è richiesto",
    lastNameRequired: "Ultimo nome è richiesto",
    lastNameOllyAlpha: "Ultimo nome può contenere solo alfabeti",
    lastNameLimit: "Ultimo nome deve essere inferiore a 50 caratteri",
    emailReuired: "E-mail è richiesta",
    emailInvalid: "Formato e-mail non valido.",
    mobileRequired: "Il numero di cellulare è richiesto",
    mobileLimit: "Il numero di cellulare deve essere inferiore a 15 cifre",
    invalidMobile: "Formato del numero di cellulare non valido.",
    emailExistAlready: "L'utente esiste già con questa email.",
    mobileExistAlready: "L'utente esiste già con questo numero di cellulare.",
    pswRequired: "La password è richiesta",
    deptRequired: "Dipartimento è richiesto",
    roleRequired: "Ruolo è richiesto",
    countryRequired: "Codice paese è richiesto",
    userUpdated: "Aggiornamento dell'utente",
    userNotUpdated: "Utente Non aggiornato",
    activateAct: "Attiva account",
    deactivateAct: "Disattivare Account",
    areYouSureYouWantToDeactivateThisFarmer: "Sei sicuro di voler disattivare questo agricoltore?",
    areYouSureYouWantToActivateThisFarmer: "Sei sicuro di voler attivare questo agricoltore?",
    userActivated: "Attivato dall'utente",
    userDeactivated: "Disattivato dall'utente",
    deactivateUser: "Disattiva l'utente",
    deactivateMsg: "Sei sicuro di voler modificare lo stato dell'utente.",
    userAdded: "Aggiunto utente",
    roleAdded: "Role Aggiunto",
    failedToAdd: "Non aggiungere",
    userNotAdded: "Utente Non Aggiunto",
    editAppUser: "Modifica utente",
    validityUpTo: "Validità fino a",
    roleEdited: "Role Modificato",
    addDepartment: "Aggiungi Dipartimento",
    editDepartment: "Modifica Dipartimento",
    department: "Dipartimento",
    noDepartment: "No Dipartimento",
    departmentNameRequired: "Il nome del Dipartimento è richiesto",
    departmentAdded: "Dipartimento Aggiunto",
    departmentEdited: "Dipartimento Modificato",
    eoriNumberRequired: "Numero EORI richiesto",
    eoriIsNumber: "EORI deve essere il numero",
    addNewSupplier: "Aggiungi nuovo fornitore",
    addNewProducer: "Aggiungi nuovo produttore",
    addNewOperator: "Aggiungi nuovo operatore",
    eoriNumber: "Numero EORI",
  },
  adminRoles: {
    adminRoles: "Admin Roles",
    roleName: "Nome del ruolo",
    description: "Designazione",
    viewPermissions: "Visualizza autorizzazioni",
    createAdminRole: "RUOLO AMMINISTRATORE",
    enterDesHere: "Inserisci la tua descrizione qui",
    deleteRole: "Eliminare i ruoli",
    deleteMsg: "Sei sicuro di voler eliminare il ruolo?",
    roleReq: "Il nome del ruolo è richiesto",
    roleLimit: "Il nome del ruolo deve essere inferiore a 15 caratteri",
    desReq: "La descrizione è richiesta",
    desLimit: "Descrizione deve essere 40 caratteri o meno",
    roleSuccess: "Role creato con successo",
    editAdminRole: "Modificare Admin Role",
    roleUpdated: "Role Aggiornato",
    noRole: "No Admin Roles Trovato",
    noRoleMsg:
      "Si prega di creare ruolo amministratore utilizzando il pulsante 'Creare Admin Role' sopra",
    roleType: "Tipo di ruolo",
  },
  roleRequest: {
    roleRequest: "Richiesta Role",
    userRole: "Ruolo utente",
    approve: "Approvo",
    reject: "Rifiuti",
    username: "nome utente",
    email: "Email",
    phone: "Telefono",
    roleAssigned: "Role Assegnato",
    roleRequested: "Role richiesto",
    requestedDate: "Data richiesta",
    updateRoleRequest: "Aggiornamento Role richiesta",
    message: "Messaggio",
    update: "Aggiornamento",
  },
  membershipplanSection: {
    defaultPlan: "PIANO DEFAULTATO",
    planDuration: "Durata del piano",
    planFee: "Costo del piano",
    satelliteReport: "RELAZIONE ANNUALE",
    advanceReport: "RELAZIONE ANNUALE",
    addMembership: "ADD MEMBRA",
    addMembershipPlan: "Aggiunta del piano di iscrizione",
    editMembershipPlan: "Modifica Piano di iscrizione",
    accessSetelite: "Accesso ai report satellitari (Set di 5 rapporti)",
    accessAdvanceReport: "Accesso ai rapporti avanzati",
    memPlanReq: "Il piano di adesione è richiesto",
    memPlanReqLimit:
      "Il piano di iscrizione deve essere inferiore a 20 caratteri",
    SatelliteReq: "Rapporto satellitare è richiesto",
    advancedReportReq: "Rapporto avanzato è richiesto",
    durationReq: "La durata dell'iscrizione è richiesta",
    feeReq: "Composizione La tariffa è richiesta",
    cantLesThenZero: "Non può essere inferiore a 0",
    roleReq: "Il ruolo dell'utente è richiesto",
    selectPlan: "Selezionare Piano",
    planType: "Tipo di piano",
    enterprise: "Imprese",
    noOfUsersAllowed: "No. di utenti consentiti",
    noOfFarms: "No. di aziende agricole",
    perUser: "Per utente",
    perFarm: "Per l'agricoltura",
    accessToDeforestationReport:
      "Accesso ai report di deforestazione (Per Utente)",
    satelliteReportPackage: "Pacchetto Rapporto satellitare",
    basicFarmLevelReports: "Rapporti di base del livello dell'azienda agricola",
    advancedFarmLevelReports:
      "Rapporti di livello avanzato dell'azienda agricola",
    largeAreaReports: "Rapporti di ampia area",
  },
  statusItems: {
    closed: "Chiuso",
    open: "Apri",
  },
  orderByItems: {
    all: "Tutti",
    dateAscending: "Data di scadenza",
    dateDescending: "Data di scadenza",
    dueDate: "Data di scadenza",
    high: "Alto",
    low: "Basso",
    medium: "Media",
  },
  record: {
    id: "ID",
    module: "Modulo",
    harvestingDate: "Data di raccolta",
    noOfTrees: "No di alberi",
    reason: "Motivazione",
    userId: "ID utente",
    appVersion: "Versione App",
    createdAt: "Creato a",
  },

  ownershipTypes: {
    EXW: "EXW (Franco Fabbrica)",
    FCA: "FCA (Franco Vettore)",
    CPT: "CPT (Trasporto Pagato Fino a)",
    CIP: "CIP (Trasporto e Assicurazione Pagati Fino a)",
    DAP: "DAP (Consegnato al Luogo)",
    DPU: "DPU (Consegnato al Luogo Scaricato)",
    DDP: "DDP (Consegnato con Dazi Pagati)",
    FAS: "FAS (Franco Lungo Bordo)",
    FOB: "FOB (Franco a Bordo)",
    CFR: "CFR (Costo e Nolo)",
    CIF: "CIF (Costo, Assicurazione e Nolo)",
  },
};
